<pbc-sorter [config]="VorlagenSorterConfig" [sorter]="vorlagen.sorter$ | async" (sorterChange)="vorlagen.sorter$.next($event)"></pbc-sorter>
